import React from 'react';

import { Verbiage } from '../verbiage.constants';
import { ConfigurerProcessor } from '../wasm_controller/processors/configurer-processor';

function WasmSidebarRevisionNotes(props) {
  const { note, onNoteChange, onClose } = props;
  return (
    <>
      <div className="wasm-sidebar-revision-title">
        <div>{Verbiage.SidebarRevision.Title}</div>
        <i className="fa fa-times" aria-label="Close" onClick={onClose} />
      </div>
      <textarea
        onFocus={() => ConfigurerProcessor.toggleHotKeys(false)}
        onBlur={() => ConfigurerProcessor.toggleHotKeys(true)}
        className="scrollbar--dark"
        placeholder="Please specify revision request"
        maxLength="2500"
        onChange={onNoteChange}
        value={note}
      />
    </>
  );
}

export default WasmSidebarRevisionNotes;
